export const data = [
    {
      id: 1,
      titulo: "SITIOS DE 500 M2 EN PUCÓN",
      contenido:
        "Cotiza con nosotros. El proyecto está ubicado dentro de la Hacienda Puerto Pucón y se rige por el Reglamento de Copropiedad de la Hacienda Puerto Pucón. Cuenta con urbanización completa que incluye agua, luz soterrada y red de alcantarillado",
      image: require("../assets/img/proyecto/texto1.jpg"),
      altImage: "imagen1",
      reverse: false,
    },
    {
      id: 2,
      titulo: "ARMONÍA CON LA NATURALEZA",
      contenido:
        "El loteo urbano Altos del Quelhue está ubicado dentro de la Hacienda Puerto Pucón, en un terreno que cuenta con vistas insuperables del Volcán Villarrica y el imponente Cerro de Quelhue.",
      image: require("../assets/img/proyecto/texto2.jpg"),
      altImage: "imagen2",
      reverse: true,
    },
    // {
    //   id: 3,
    //   titulo: "ESPECTACULAR ACCESO",
    //   contenido:
    //     "Ubicado a metros del Gimnasio Olímpico emplazado la Ciudad del Deporte Ecoparque de Pucón; el condominio cuenta con dos accesos: uno por la hacienda Puerto Pucón, en el Camino Internacional, y otro pavimentado por camino al Ecoparque, que conecta rápidamente -a sólo 5 minutos- con el centro urbano de Pucón.",
    //   image: require("../assets/img/proyecto/texto3.jpg"),
    //   altImage: "imagen3",
    //   reverse: false,
    // }
  ];